import { readonly, ref } from "vue";
import axios from "axios";
import { useAuthStore } from "@/stores/auth.js";

/*PARA INPUT DE TIPO AUTOCOMPLETE Y DROPDOWN*/
export function useAxiosDropdown() {
    const results = ref(null);
    const error = ref(null);
    const loading = ref(true);
    const authStore = useAuthStore();
    const makeRequest = async (url) => {
        loading.value = true;
        error.value = null;;
        try {
            const resp = await axios({
                method: "get",
                url: url,
                headers: {
                     Authorization: `Bearer ${authStore.token}`,
                },
            });
            if (resp.status == 200 || resp.status == 201) {
                results.value = resp.data;
            }
        } catch (err) {
            error.value = err.message;
        } finally {
            loading.value = false;
        }
    };
    return {
        makeRequest,
        results: readonly(results),
        error,
    };
}